import styled from 'styled-components';

export const RateRankinGraphicContainer = styled.div`
    margin-top: 1em;
    display: grid;
    grid-template-columns: 1fr;
    grid-row-gap: .5em
`;